import { Component, Input } from "@angular/core";
import { Card } from "@shared/models/products.model";
import { MaskUtilService } from "@core/services/utils/mask-util.service";
import { IonModal, ModalController, ToastController } from "@ionic/angular";
import { Clipboard } from "@capacitor/clipboard";
import { ApiService } from "@core/services/api/api.service";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { map } from "rxjs/operators";
import { AlertService } from "@core/services/alert/alert.service";
import { LoadingService } from "@core/services/loading/loading.service";

@UntilDestroy()
@Component({
    selector: 'app-card-requisites',
    templateUrl: './card-requisites.component.html',
    styleUrls: ['./card-requisites.component.scss'],
    standalone: false
})
export class CardRequisitesComponent {
  @Input() modal: IonModal;
  @Input() staticHeight: boolean;
  @Input() product: Card;
  @Input() userPhone: string;

  public cardMask = {
    mask: MaskUtilService.cardMask
  }

  constructor(
    private toastController: ToastController,
    private apiService: ApiService,
    private alertService: AlertService,
    private modalController: ModalController,
    private loadingService: LoadingService
  ) {
  }

  async copyInfo(value: string, type: string) {
    const prefix = type === 'cardNumber' ? 'Номер карты' : 'Срок действия'
    let toastMessage = prefix + ' скопирован';
    try {
      await Clipboard.write({
        string: value
      });
    } catch (e) {
      toastMessage = 'Не удалось скопировать ' + prefix.toLowerCase();
    }
    const toast = await this.toastController.create({
      mode: 'ios',
      message: toastMessage,
      duration: 3000
    });
    await toast.present();
  }

  sendCvv() {
    this.loadingService.showLoader(true);
    this.apiService.post('rest/personal/card_cvc', {
      cardId: this.product.id,
      phoneNumber: '+' + this.userPhone
    }).pipe(
        map((res: any) => {
          if (res.errorInfo || res.errorCode) {
            throw res;
          }
          return res
        }),
        untilDestroyed(this)
    )
        .subscribe(
            (res) => {
              this.loadingService.showLoader(false);
              this.alertService.showInfoAlert('CVV код направлен сообщением');
              this.modalController.dismiss();
            },
            (err: any) => {
              this.loadingService.showLoader(false);
              const message = err?.errorInfo || err?.errorText || 'Не удалось отправить CVV код. Повторите попытку позже';
              this.alertService.showErrorAlert(message);
            }
        )

  }
}
